import request from '@/utils/request'

// 세금계산서 목록 조회
export function getTaxInvoiceManage (params, isNotify) {
  return request({
    url: `/api/getTaxInvoiceManage`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}
// 세금계산서 삭제
export function deleteTaxInvoice (params, isNotify) {
  return request({
    url: `/api/deleteTaxInvoice`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'deleted' }
  })
}
// 세금계산서 발급
export function IssuanceTaxInvoice (params, isNotify) {
  return request({
    url: `/api/IssuanceTaxInvoice`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'saved' }
  })
}
// 미발행 업체 조회
export function getUnissuedClient (params, isNotify) {
  return request({
    url: `/api/getUnissuedClient`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}